import React from 'react';
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';

interface RevenueConfigProps {
  value: 'START_DATE' | 'END_DATE' | 'EITHER_DATE';
  onChange: (value: 'START_DATE' | 'END_DATE' | 'EITHER_DATE') => void;
  variant?: 'full' | 'compact';
}

export const RevenueConfig: React.FC<RevenueConfigProps> = ({ 
  value, 
  onChange, 
  variant = 'full' 
}) => {
  return (
    <Box>
      {variant === 'full' && (
        <>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
            Revenue Calculation Method
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              mb: 2
            }}>
            Determines how projects are included in revenue calculations for the selected date range
          </Typography>
        </>
      )}
      <FormControl fullWidth size={variant === 'compact' ? 'small' : 'medium'} sx={{ mt: 1 }}>
        <InputLabel>Revenue Calculation Method</InputLabel>
        <Select
          value={value}
          label="Revenue Calculation Method"
          onChange={(e) => onChange(e.target.value as 'START_DATE' | 'END_DATE' | 'EITHER_DATE')}
        >
          <MenuItem value="START_DATE">Start Date within Selected Range</MenuItem>
          <MenuItem value="END_DATE">End Date within Selected Range</MenuItem>
          <MenuItem value="EITHER_DATE">Either Start or End Date within Selected Range</MenuItem>
        </Select>
        <FormHelperText>
          {variant === 'full' 
            ? 'How projects are filtered for the Revenue tile based on the selected date range'
            : 'Project date filtering method for Revenue calculation'
          }
        </FormHelperText>
      </FormControl>
    </Box>
  );
};

export default RevenueConfig; 